module.exports = "/assets/021e68a2cbf81d06dbcd78ae390ae7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ED.png
// module id = 1332
// module chunks = 0